import React from "react";

import logo from "../../res/logo/logo_mini.png";


export default function PageLoading(props){
    return <div className="page-loading">
        <img className="logo" src={logo}/>
    </div>
}